import React from "react";
import ParkkiTheme from "themes/ParkkiTheme";
import styled from "@emotion/styled";

const Container = styled.div`
  margin-top: ${ParkkiTheme.spacings.base};
  display: flex;
  flex-direction: ${(props: { type: "column" | "row" }) => props.type};
  flex: 1;
`;

const LabelContainer = styled.div`
  display: flex;
  flex-direction: row;
  font-size: ${ParkkiTheme.fontSizes.small};
  align-items: center;
  margin-left: ${ParkkiTheme.spacings.base};
`;

const LabelColor = styled.div`
  height: 10px;
  width: 20px;
  margin-right: ${ParkkiTheme.spacings.teeny};
  background-color: ${(props: { backgroundColor: string }) =>
    props.backgroundColor};
`;

type Props = {
  data: { label: string; color: string; styles?: { label: {} } }[];
  type: "column" | "row";
};

function GraphLegend({ data, type }: Props): JSX.Element {
  return (
    <Container type={type}>
      {data?.map((item, index) => (
        <LabelContainer key={item.label}>
          <LabelColor backgroundColor={item?.color} />
          {item.label}
        </LabelContainer>
      ))}
    </Container>
  );
}

GraphLegend.defaultProps = {
  type: "row",
};

export default GraphLegend;
